import { BadRoutingDTO } from 'src/app/shared/interfaces/bad-routing/bad-routing-dto.interface';

export class BadRoutingParams {
  commentaires?: string;
}

export class BadRouting {
  serviceId: number;
  limiterNatures: boolean;
  description: string;

  constructor(data?: BadRoutingDTO) {
    Object.assign(this, data);
    this.description = '';
  }
}
